import type { SxProps, Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

import {
  MAX_BOARD_DIMENSION,
  MIN_BOARD_DIMENSION
} from "./andonBoard/andonBoardLayoutEditor.utils";

export const workstationTileTextSx: SystemStyleObject<Theme> = {
  userSelect: "none",
  cursor: "inherit"
};

export const workstationTileBoxSx: SystemStyleObject<Theme> = {
  cursor: "pointer",
  userSelect: "none"
};

export const workstationLoadingSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  boxSizing: "border-box"
};

export const workstationNotFoundSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  backgroundColor: "#ffebee",
  border: "2px dashed #ef5350",
  boxSizing: "border-box",
  p: 0.5,
  gap: 0.5,
  cursor: "pointer"
};

export const workstationTileSx: SystemStyleObject<Theme> = {
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-evenly",
  width: "100%",
  height: "100%",
  overflow: "hidden",
  boxSizing: "border-box",
  p: 0.25,
  ...workstationTileBoxSx
};

export const workstationLineTextSx: SystemStyleObject<Theme> = {
  width: "100%",
  textAlign: "center",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  fontWeight: 400,
  minHeight: "1.2em",
  ...workstationTileTextSx
};

export const workstationFcAbbreviationSx = (
  fontSize: string
): SystemStyleObject<Theme> => ({
  position: "absolute",
  top: 2,
  left: 4,
  maxWidth: "45%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: `max(8px, calc(${fontSize} * 0.5))`,
  fontWeight: 500,
  lineHeight: 1,
  color: "rgba(0, 0, 0, 0.45)",
  pointerEvents: "none"
});

export const workstationRolesSx = (
  fontSize: string
): SystemStyleObject<Theme> => ({
  position: "absolute",
  top: 2,
  right: 4,
  maxWidth: "55%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: `max(8px, calc(${fontSize} * 0.5))`,
  fontWeight: 500,
  lineHeight: 1,
  color: "rgba(0, 0, 0, 0.45)",
  pointerEvents: "none",
  textAlign: "right"
});
export const BORDER_OVERLAY_WIDTH = 3;
export const BORDER_OVERLAY_RGL_MARGIN = 10;

export const BOARD_DIMENSION_MARKS = [
  { value: 1, label: "1" },
  { value: 10, label: "10" },
  { value: 20, label: "20" }
];

export const borderOverlaySx = (
  columns: number,
  rowTemplate: string
): SystemStyleObject<Theme> => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  pointerEvents: "none",
  display: "grid",
  gridTemplateColumns: `repeat(${columns}, 1fr)`,
  gridTemplateRows: rowTemplate,
  gap: 0,
  padding: `${BORDER_OVERLAY_RGL_MARGIN / 2}px`,
  boxSizing: "border-box",
  zIndex: 1
});

export const getRestrictedDimensionSliderSx = (
  floor: number
): SystemStyleObject<Theme> | undefined => {
  if (floor <= MIN_BOARD_DIMENSION) {
    return undefined;
  }

  const restrictedPercent =
    ((floor - MIN_BOARD_DIMENSION) /
      (MAX_BOARD_DIMENSION - MIN_BOARD_DIMENSION)) *
    100;

  return {
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: "50%",
      transform: "translateY(-50%)",
      width: `${restrictedPercent}%`,
      height: 4,
      borderRadius: 1,
      backgroundColor: "grey.400",
      zIndex: 1,
      pointerEvents: "none"
    },
    "& .MuiSlider-thumb": {
      zIndex: 2
    }
  };
};
